import { Routes } from '@angular/router';
import { AdmFormIntroInfoComponent } from '../shared/adm-form-intro-info/adm-form-intro-info.component';
import { AdmFormDocDptoComponent } from '../shared/adm-form-doc-dpto/adm-form-doc-dpto.component';
import { AdmFormScatterGraphComponent } from '../shared/adm-scatter-graph/adm-form-scatter-graph/adm-form-scatter-graph.component';
import { T1OListComponent } from './t1-o/t1-o-list/t1-o-list.component';
import { T1OFormComponent } from './t1-o/t1-o-form/t1-o-form.component';

export const OPORT_ROUTES: Routes = [
    { path: 'list', component: T1OListComponent },
    { path: 'add/:idtier1', component: T1OFormComponent },
    { path: 'edit/:id', component: T1OFormComponent },
    { path: 'add-info/:id', component: AdmFormIntroInfoComponent },
    { path: 'add-rep/:id', component: AdmFormDocDptoComponent },
    { path: 'add-scatter-graph/:id', component: AdmFormScatterGraphComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'list' }
];